import { createAction, props } from '@ngrx/store';
import { SingleGraphError } from 'src/app/common-components/errors/models/error-message';
import { UserDetailSaveEvent } from '../models/user-detail-form-submit-event';
import { UserVerificationEmailRequestModel } from '../models/user-verification-email-request.model';
import {
   GetUserDetail_extensionGroupsConnection,
   GetUserDetail_extensionsConnection,
   GetUserDetail_user,
} from '../queries/generated/GetUserDetail';
import { SaveUser } from '../queries/generated/SaveUser';

export const userDetailLoad = createAction('[User Detail] Load');

export const userDetailCancel = createAction('[User Detail] Cancel');

export const userDetailAccessDenied = createAction('[User Detail] Access Denied');

export const loadUserDetailsSuccess = createAction(
   '[API] Load User Success',
   props<{
      data: GetUserDetail_user;
      extensions: GetUserDetail_extensionsConnection;
      extensionGroups: GetUserDetail_extensionGroupsConnection;
   }>()
);

export const loadSystemUserDetailsSuccess = createAction(
   '[API] Load System User Success',
   props<{
      data: GetUserDetail_user;
      extensions: GetUserDetail_extensionsConnection;
      extensionGroups: GetUserDetail_extensionGroupsConnection;
   }>()
);

export const loadUserDetailsFailure = createAction('[API] Load User Failure', props<SingleGraphError>());

export const saveUserDetail = createAction('[User Detail] Save', props<UserDetailSaveEvent>());

export const saveUserDetailSuccess = createAction('[User Detail] Save Success', props<{ data: SaveUser }>());

export const saveUserDetailFailure = createAction('[User Detail] Save Failure', props<SingleGraphError>());

export const deleteUser = createAction('[User Detail] Delete User', props<{ userId: number; name: string }>());

export const unlockUser = createAction('[User Detail] Unlock User Account', props<{ userId: number; name: string }>());

export const unlockUserSuccess = createAction('[User Detail] Unlock User Success', props<{ name: string }>());

export const unlockUserFailure = createAction('[User Detail] Unlock User Failure', props<SingleGraphError>());

export const deleteUserSuccess = createAction('[User Detail] Delete User Success', props<{ name: string }>());

export const deleteUserFailure = createAction('[User Detail] Delete User Failure', props<SingleGraphError>());

export const privilegesLoad = createAction('[Role Detail] Load Privileges');

export const resendVerificationEmail = createAction(
   '[User Detail] Resend Verification Email',
   props<UserVerificationEmailRequestModel>()
);

export const resendVerificationEmailSuccess = createAction('[User Detail] Resend Verification Email Success');

export const resendVerificationEmailFailure = createAction(
   '[User Detail] Resend Verification Email Failure',
   props<SingleGraphError>()
);

export const userDetailRouteCorrected = createAction('[User Detail] Route Corrected');
